import { c as _c } from "react/compiler-runtime";
import { NavArrowDown, NavArrowUp } from '@byway/icons';
import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react';
import clsx from 'clsx';
import type { AccordionProps } from './Accordion.types';
export function Accordion(t0) {
  const $ = _c(16);
  let children;
  let defaultOpen;
  let isBigTitle;
  let isFullBleed;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      children,
      title,
      defaultOpen,
      isFullBleed,
      isBigTitle,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = defaultOpen;
    $[3] = isBigTitle;
    $[4] = isFullBleed;
    $[5] = props;
    $[6] = title;
  } else {
    children = $[1];
    defaultOpen = $[2];
    isBigTitle = $[3];
    isFullBleed = $[4];
    props = $[5];
    title = $[6];
  }
  let t1;
  if ($[7] !== children || $[8] !== isBigTitle || $[9] !== isFullBleed || $[10] !== props || $[11] !== title) {
    t1 = t2 => {
      const {
        open
      } = t2;
      return <div><DisclosureButton className={clsx("flex justify-between w-full text-left bg-blue-200 rounded-lg p-16px typography-emphasis-1 hover:bg-yellow-200 focus:outline-none focus-visible:ring focus-visible:ring-primary-600 focus-visible:ring-opacity-75", {
          "px-4": isFullBleed,
          "text-xl": isBigTitle
        })} {...props}>{title}{open ? <NavArrowUp decorative={true} size="large" /> : <NavArrowDown decorative={true} size="large" />}</DisclosureButton><Transition as="div" enter="transition duration-100 ease-out" enterFrom="transform scale-95 opacity-0" enterTo="transform scale-100 opacity-100" leave="transition duration-75 ease-out" leaveFrom="transform scale-100 opacity-100" leaveTo="transform scale-95 opacity-0"><DisclosurePanel className={clsx("px-2 pt-4 pb-2 text-gray-500 typography-body-1", {
            "px-0": isFullBleed
          })}>{children}</DisclosurePanel></Transition></div>;
    };
    $[7] = children;
    $[8] = isBigTitle;
    $[9] = isFullBleed;
    $[10] = props;
    $[11] = title;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== defaultOpen || $[14] !== t1) {
    t2 = <Disclosure defaultOpen={defaultOpen}>{t1}</Disclosure>;
    $[13] = defaultOpen;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}